import { StyleSheet, Platform } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export const getBadgeSize = notification => {
  const length = notification.toString().length;
  if (String(notification) === '0') {
    return 0;
  } else if (length === 1) {
    return 20;
  } else if (length > 1) {
    return (notification.toString().length + 1) * 8;
  }
};
export default StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: Platform.OS === 'ios' ? 0 : 5,
    paddingTop: 4,
    zIndex: 3,
  },
  iconContainer: {
    flexDirection: 'row',
    position: 'relative',
  },
  trayIconContainer: { position: 'absolute' },
  badgeStyle: notification => ({
    width: getBadgeSize(notification),
    left: 18,
  }),
  title: {
    color: Colors.dark_grey,
    fontSize: 16,
    letterSpacing: 0,
    lineHeight: 16,
    marginHorizontal: 5,
    marginTop: 2.5,
    textAlign: 'center',
    width: 70,
  },
});
